/**
 * Convert app message objects to API history format.
 * @param {Array<{ senderName: string, content: string }>} previousMessages
 * @returns {Array<{ role: 'user' | 'assistant', content: string }>}
 */
const toHistoryFormat = (previousMessages) => {
  if (!Array.isArray(previousMessages) || previousMessages.length === 0) {
    return [];
  }
  return previousMessages.map((m) => ({
    role: m.senderName === "Zucky" ? "assistant" : "user",
    content: m.content ?? "",
  }));
};

/**
 * Send a user message to the backend with optional conversation history.
 * @param {string} message - Current user message (user_input).
 * @param {function(string): void} updateMessages - Callback with the assistant reply.
 * @param {Array<{ senderName: string, content: string }>} [previousMessages=[]] - All messages in the conversation so far (before this message). Not including the current message.
 */
export const sendRequest = (message, updateMessages, previousMessages = []) => {
  const url = "https://chatbot-server-beta.vercel.app/send_message";
  const formData = new FormData();
  formData.append("user_input", message);
  formData.append("history", JSON.stringify(toHistoryFormat(previousMessages)));

  fetch(url, {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data, data?.reply);
      updateMessages(data?.reply);
    })
    .catch((error) => console.error("Error:", error));
};

export const getCredits = async () => {
  try {
    const url = 'https://chatbot-server-beta.vercel.app/credits';
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching credits:', error);
    return {
      status: "error",
      message: "Unable to fetch credits",
      error: error.message
    };
  }
};